import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { config } from './config';
import languageMap from '../languageMap';
import './MyEvents.css';

export default function MyEvents(props) {
  const history = useHistory();
  const [userDetails, setUserDetails] = useState(null);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);

  const selectedLanguage = languageMap.config.selectedLanguage || 'en';
  const { username } = props.location.state || {};

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        if (!username) {
          console.error('Username is empty');
          return;
        }
        
        const response = await axios.get(config.apiUrl + `/get_user_details/${username}`);

        if (isMounted) {
          if (response.data && response.data.username) {
            setUserDetails(response.data);
            fetchEvents(response.data.username); // Fetch events right after setting user details
          } else {
            console.error('Invalid response format:', response.data);
            setError(languageMap.errorFetchingUserDetails[selectedLanguage] || 'Error fetching user details');
          }
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
        setError(languageMap.errorFetchingUserDetails[selectedLanguage] || 'Error fetching user details');
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [username, selectedLanguage]);

  const fetchEvents = async (username) => {
    try {
      const response = await axios.get(config.apiUrl + `/get_all_events/${username}`);

      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching events:', error);
      setEvents([]);
      setError(languageMap.errorFetchingEvents[selectedLanguage] || 'Error fetching events');
    }
  };

  const handleCreateNewEvent = () => {
    history.push(`/create-new-event/${username}`, { username: username });
  };

  const handleEventClick = (event_name) => {


    if (!event_name || !username) {
      console.error('Clicked event has undefined name or username');
      return;
    }

    history.push(`/event-details/${event_name}`, { event_name: event_name, username: username });
  };

  return (
    <div className='MyEvents'>
      <h1 className='title' style={{ color: '#333' , marginTop:100}}>{languageMap.myEventsTitle[selectedLanguage] || 'My Events'}</h1>
      <div className="events-container">
        <div className="scrollable-events">
          <ul className="events-list">
            {events.map((event_name, index) => (
              <li 
                key={index} 
                onClick={() => handleEventClick(event_name)}
              >
                {event_name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="button-container">
        <button className="circular-button" onClick={handleCreateNewEvent}>{languageMap.createNewEventButton[selectedLanguage] || 'Create New Event'}</button>
      </div>

      {error && <p>{error}</p>}


    </div>
  );
}
